<template lang="pug">
  div.status
    div.stat
      div.sizes
        div.size
          div.tit 横幅
          div.meter {{ sizeWidth * 10 }}
          div.mm (必要最低限幅:{{ fixWidth * 10 }})mm
        div.size
          div.tit 高さ
          div.meter {{ sizeHeight * 10 }}
          div.mm mm
        div.size
          div.tit 奥行
          div.meter {{ sizeDepth * 10 }}
          div.mm mm
        div.size
          div.tit 床上
          div.meter {{ underfloor * 10 }}
          div.mm mm
      Clothing(:flg="flgCloth",@change="clothing")
      Views
    div.opt
      div.help(@click="show")
          img(src="@/assets/ico_important.svg")
          |  最低限必要な横幅、高さ、奥行について
      div.btn
        a(href="https://fitrack.jp/support/",target="_blank") 商品サポートはこちら
    modal(name="modal-content",width="820",height="570")
      div.btn-close(@click="hide")
        img(src="@/assets/ico_close.svg")
      ModalHelp
</template>
<script>
import Views from './Views.vue';
import Clothing from './Clothing.vue';
import ModalHelp from '../parts/ModalHelp.vue';
export default {
  name: 'Status',
  components: {
    ModalHelp,
    Clothing,
    Views
  },
  data () {
    return {
      timer: {},
      set: {},
      size: [],
      fixWidth: 0,
      fixDepth: 0,
      sizeWidth: 0,
      sizeHeight: 0,
      sizeDepth: 0,
      underfloor: 0,
      flgCloth: false,
      isAct: 1
    };
  },
  computed: {
  },
  watch: {
    number () {
      this.update();
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      let me = this;
      me.set = me.sets[me.number];
      if (me.set !== undefined) {
        me.size = me.set.size;
        me.sizeWidth = Math.round((me.size[0]) * 10) / 10;
        me.sizeHeight = Math.round((me.size[1] + me.size[3] + me.size[4]) * 10) / 10;
        me.sizeDepth = Math.round((me.size[2]) * 10) / 10;
        me.underfloor = me.size[3] || 0;
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.updateFix();
        }, 100);
      }
    },
    clothing (event) {
      this.flgCloth = event;
    },
    show () {
      this.$modal.show('modal-content');
    },
    hide () {
      this.$modal.hide('modal-content');
    }
  },
  created () {
  }
};
</script>

<style lang="stylus" scoped>
  .status
    position absolute
    top 60px
    right 20px
    z-index 2
    text-align right
    .stat
      display flex
      align-items center
      text-align left
    .sizes
      display flex
      align-items center
      font-size 12px
      color #666666
      pointer-events none
      user-select none
      .size
        display flex
        align-items flex-end
        margin-right 20px
        .meter
          font-size 14px
          margin 0 5px
          display inline-block
          width 40px
          text-align right
    .opt
      text-align right
      margin-top 15px
      display inline-block
    .help
      display inline-block
      font-size 12px
      color #cc0000
      text-decoration underline
      cursor pointer
      user-select none
      img
        display inline-block
        vertical-align middle
        margin-top -2px
        margin-right 5px
        pointer-events none
    .btn
      cursor pointer
      display inline-block
      vertical-align middle
      margin-left 10px
      a
        padding 4px 10px
        display block
        background-color #2e7c80
        color #ffffff
        border-radius 5px
        text-decoration none
        font-weight bold
        font-size 12px
  .btn-close
    position absolute
    top 20px
    right 20px
    cursor pointer
</style>



// WEBPACK FOOTER //
// src/components/status/Status.vue